@let mode = colorMode() ?? 'dark';
<div class="about">
  <header class="about__banner">
    <img class="about__rooms-logo" [src]="'/assets/logo_' + mode + '.svg'" alt="Rooms" />
    <span class="about__divider" aria-hidden="true"></span>
    <a
      class="about__powered"
      href="https://odin.4players.io"
      target="_blank"
      rel="noopener noreferrer">
      <span class="about__powered-label">{{ 'Powered by' | translate }}</span>
      <img class="about__odin-logo" [src]="'/assets/odin_' + mode + '.svg'" alt="ODIN" />
    </a>
  </header>

  <andor-tabs
    class="about__tabs"
    [tabs]="tabs"
    [active]="activeTab()"
    (activeChange)="select($event)"></andor-tabs>

  <div class="about__panel" role="tabpanel" [attr.aria-label]="activeTab()?.label">
    <div class="about__content">
      @switch (activeId()) {
        @case ('about') {
          <section class="about__info">
            <h3 class="about__tagline">{{ 'Trusted Communication Made Simple' | translate }}</h3>
            <p class="about__meta">
              <span class="about__version">
                <strong>{{ 'Version' | translate }}:</strong>
                {{ version }}
              </span>
              <span>{{ 'Made with ♥ by 4Players GmbH' | translate }}</span>
            </p>
            <ul class="about__links">
              @for (link of legalLinks; track link.url) {
                <li>
                  <a
                    class="about__link"
                    [href]="link.url"
                    target="_blank"
                    rel="noopener noreferrer">
                    <fa-icon class="about__link-icon" [icon]="link.icon"></fa-icon>
                    <span class="about__link-label">{{ link.label | translate }}</span>
                    <fa-icon
                      class="about__link-external"
                      [icon]="faArrowUpRightFromSquare"></fa-icon>
                  </a>
                </li>
              }
            </ul>
          </section>
        }
        @case ('changelog') {
          <andor-changelog></andor-changelog>
        }
        @case ('licenses') {
          <andor-licenses></andor-licenses>
        }
      }
    </div>
  </div>
</div>
